import React from 'react'
import MultipleEntryInfo from './MultipleEntryInfo'
import { ConfiguratorProductDetails } from '../../ConfiguratorSharedTypes'
interface ViewMultipleEntryInfo {
  navigateToConfirm: React.Dispatch<React.SetStateAction<any>>
  productDetails?: ConfiguratorProductDetails | null
  setAddItemsFromSideNav?: any
  setItemDetails?: any
}

const MultiProductEntry: React.FC<ViewMultipleEntryInfo> = (props) => {
  const { setAddItemsFromSideNav, setItemDetails } = props
  setAddItemsFromSideNav(true)
  return (
    <MultipleEntryInfo
      navigate={props.navigateToConfirm}
      productDetails={props.productDetails}
      setItemDetails={setItemDetails}
    />
  )
}
export default MultiProductEntry
